import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b53d690"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__rec-progress-bar" }
const _hoisted_2 = {
  key: 0,
  class: "bubbles"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "bubble-label" }
const _hoisted_5 = { class: "bubble-text" }

import { computed, onMounted, ref, watch } from 'vue';
  import { useStore } from 'vuex';
  import { themingCssClass } from "../../mixins/theming-mixin";
  import { recProps } from '../../mixins/rec-component';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-progress-bar',
  props: {...recProps()},
  setup(__props) {

  const props = __props;
  
  const store = useStore();
  const visitedKeys = ref<Array<string>>([]);

  const currentAreaKey = computed(() => store.state.exam.currentAreaKey);
  const moreThanOneElement = computed(() => ((props.description || {}).steps || []).length > 1)

  const select = (newKey: string) => {
    store.commit("updateCurrentAreaKey", newKey);
  };
  const bubbleCssClasses = (step: any) => {
    const result = [];

    result.push(themingCssClass("border"));

    if (step.key === currentAreaKey.value) {
      result.push("active");
      result.push(themingCssClass("inverted"));
    } else {
      result.push(themingCssClass("normal"));
    }
    if (visitedKeys.value.indexOf(step.key) >= 0) result.push("visited");

    return result;
  };

  watch(currentAreaKey, (newVal: any) => {
    if (visitedKeys.value.indexOf(newVal) < 0) {
      visitedKeys.value.push(newVal);
    }
  }, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (moreThanOneElement.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.description.steps, (step) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["bubble", bubbleCssClasses(step)]),
              key: step.key,
              onClick: ($event: any) => (select(step.key))
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(step.label), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(step.text), 1)
            ], 10, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})